import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PostInspectionMarketplace from "./component";
import { getC2cListingData, initiateListing } from "./action";
import { withRouter } from "react-router";

const mapStateToProps = ({
    postInspectionDiy: {
        inspectionResponse,
        pickupDetail
    },
    user: {
        secureToken,
        userId,
        name,
        email,
        mobile
    },
    cities: {selectedCity}
}) => {
    return {
        secureToken,
        userId,
        name,
        email,
        mobile,
        selectedCity,
        inspectionResponse,
        pickupDetail
    };
};
const mapDispatchToProps = (dispatch) => bindActionCreators({
    getC2cListingDataConnect: getC2cListingData,
    initiateListingConnect: initiateListing
}, dispatch);

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(PostInspectionMarketplace));
